<template>
  <b-navbar type="dark" variant="primary" sticky ref="navbar" class="nav-bar">
    <b-button
      v-b-toggle.main-sidebar
      class="mr-2"
      variant="primary"
      pill
      v-if="isAuthenticated"
    >
      <font-awesome-icon :icon="['fas', 'bars']" />
    </b-button>
    <b-navbar-brand :href="getHome">
      {{ buildTitle(isMobile) }}
    </b-navbar-brand>
    <b-navbar-nav class="ml-auto">
      <LogInOut />
    </b-navbar-nav>
  </b-navbar>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator'
import { navBarTitleMapper } from '@/store/modules/navbar'
import { userMappers } from '@/store/modules/user'
import { clientBase } from '@/api/httpAxios'
import { mobileWidthMapper } from '@/store/modules/mobileWidth'
import LogInOut from '@/components/pages/home/components/navbar/components/LogInOut.vue'

const Mappers = Vue.extend({
  computed: {
    ...mobileWidthMapper.mapGetters(['isMobile']),
    ...userMappers.mapGetters(['isAuthenticated']),
    ...navBarTitleMapper.mapGetters(['buildTitle']),
  },
})

@Component({
  components: { LogInOut },
})
export default class Navbar extends Mappers {
  private homePage = clientBase
  private get getHome() {
    return this.homePage
  }
}
</script>

<style lang="scss">
@import '@/scss/_colors.scss';

.nav-bar {
  .navbar-brand {
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
  }
  .nav-item {
    background-color: inherit;
  }
  .nav-item:hover {
    background-color: map-get($french-palette, 'blue-4');
  }
}
</style>
